import type { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react'

import {
  getBreakpointParts,
  hiddenDown,
  hiddenUp,
} from '@twistopayments/design-system/styles'
import type { BreakpointVariants } from '@twistopayments/design-system/styles'

type Props<T extends ElementType> = {
  as?: T
  className?: string
  children: ReactNode | ReactNode[]
  breakpoint: BreakpointVariants
} & ComponentPropsWithoutRef<T>

export const Hidden = <T extends ElementType = 'div'>({
  as,
  children,
  className,
  breakpoint,
  ...rest
}: Props<T>) => {
  const Element = as || 'div'
  const [breakpointSize, direction] = getBreakpointParts(breakpoint)

  return (
    <Element
      className={className}
      css={[
        direction.toLowerCase() === 'down'
          ? hiddenDown(breakpointSize)
          : hiddenUp(breakpointSize),
      ]}
      {...rest}
    >
      {children}
    </Element>
  )
}
